import { TOAST_ERROR, EXTENSIBLE_TOAST_ERROR, CUSTOM_TOAST_ALERT } from "../../components/UI/Alert";

import * as actionTypes from "./actionTypes";
import { setExceptionReporting, unsetExceptionReporting } from "./exceptionReporting";

const setAlert = (alertConf) => {
  return {
    alertConf: alertConf,
    type: actionTypes.SET_ALERT,
  };
};

const unsetAlert = () => {
  return {
    type: actionTypes.UNSET_ALERT,
  };
};

export const showAlert = (message, dispatch, type = TOAST_ERROR, requestId = null) => {
  dispatch(
    setAlert({
      dismiss: () => {
        dispatch(unsetAlert());
      },
      message,
      requestId,
      showExceptionReporting: () => {
        dispatch(
          setExceptionReporting({
            dismiss: () => {
              dispatch(unsetExceptionReporting());
            },
            requestId,
          }),
        );
      },
      type,
    }),
  );
};

export const showAlertWithAction =
  (message, type = TOAST_ERROR) =>
  (dispatch) => {
    dispatch(
      setAlert({
        dismiss: () => {
          dispatch(unsetAlert());
        },
        message,
        type,
      }),
    );
  };

export const showAlertWithActionAndCustomButton =
  (message, buttonAction, buttonText, type = EXTENSIBLE_TOAST_ERROR) =>
  (dispatch) => {
    dispatch(
      setAlert({
        buttonAction,
        buttonText,
        dismiss: () => {
          dispatch(unsetAlert());
        },
        message,
        type,
      }),
    );
  };

export const showAlertWithCustomHTML =
  (customHTML, type = CUSTOM_TOAST_ALERT, dismiss = false, customClass = undefined) =>
  (dispatch) => {
    if (dismiss) {
      dispatch(unsetAlert());
    } else {
      dispatch(
        setAlert({
          customClass,
          customHTML,
          dismiss: () => {
            dispatch(unsetAlert());
          },
          type,
        }),
      );
    }
  };
